import React from 'react';
import { Monitor, Smartphone } from 'lucide-react';

const MobileMessage = () => (
  <div className="flex flex-col items-center justify-center h-screen bg-gray-100 p-4 text-center">
    <div className="max-w-md">
      <Monitor size={64} className="mx-auto text-indigo-500 mb-6" />
      <h1 className="text-3xl font-bold text-gray-800 mb-4">This Dashboard is Best on Desktop</h1>
      <p className="text-gray-600 mb-8">
        For the best experience, including access to all features like drag-and-drop and detailed analytics, please sign in on a desktop or laptop computer.
      </p>
      <div className="flex items-center justify-center gap-2 text-gray-500">
        <Smartphone size={20} />
        <span>Mobile view is not supported</span>
      </div>
    </div>
  </div>
);

export default MobileMessage;
